import { useEffect, useRef, useState, useCallback } from 'react';
import { useCollaborationParentState, useUpdateCollaborationParentState } from '../../hooks/useCollaborationParentState';
import { INTERACTIVE_MODE_PLUGIN } from '../../types/PluginTypes';
const getParentPathname = () => {
  try {
    var _window$parent$locati;
    return (_window$parent$locati = window.parent.location) === null || _window$parent$locati === void 0 ? void 0 : _window$parent$locati.pathname;
  } catch (___error) {
    return '';
  }
};
const getParentAppName = () => {
  try {
    var _window$parent$hubspo;
    // @ts-expect-error - this is a hack to get the app name from the parent window
    return (_window$parent$hubspo = window.parent.hubspot) === null || _window$parent$hubspo === void 0 || (_window$parent$hubspo = _window$parent$hubspo.bender) === null || _window$parent$hubspo === void 0 ? void 0 : _window$parent$hubspo.currentProject;
  } catch (___error) {
    return '';
  }
};
const safeParentAddEventListener = (type, listener) => {
  try {
    window.parent.addEventListener(type, listener);
  } catch (___error) {
    // Do nothing
  }
};
const safeParentRemoveEventListener = (type, listener) => {
  try {
    window.parent.removeEventListener(type, listener);
  } catch (___error) {
    // Do nothing
  }
};
export const useOnParentPathnameChange = (...calls) => {
  const pathNameRef = useRef(getParentPathname());
  const appNameRef = useRef(getParentAppName());
  const {
    resetParentAppState
  } = useUpdateCollaborationParentState();
  const {
    getParentAppStateByPlugin
  } = useCollaborationParentState();
  useEffect(() => {
    const handleLocationChange = () => {
      const newPathName = getParentPathname();
      const newAppName = getParentAppName();
      const {
        customFEActions
      } = getParentAppStateByPlugin(INTERACTIVE_MODE_PLUGIN) || {};
      const hasAppNameChanged = newAppName !== appNameRef.current;
      const hasPathNameChanged = newPathName !== pathNameRef.current &&
      // Set in useInteractiveModeSession by the consumer
      // If true, the hook will not update the path when the user changes the path (if in the same app)
      !(customFEActions !== null && customFEActions !== void 0 && customFEActions.ignorePathChanges);
      if (hasAppNameChanged || hasPathNameChanged) {
        pathNameRef.current = newPathName;
        appNameRef.current = newAppName;
        calls.forEach(call => call(newPathName));
        resetParentAppState();
      }
    };
    // Listen for navigation events in parent window
    safeParentAddEventListener('popstate', handleLocationChange);
    // Listen for programmatic history changes
    safeParentAddEventListener('pushstate', handleLocationChange);
    safeParentAddEventListener('replacestate', handleLocationChange);
    return () => {
      safeParentRemoveEventListener('popstate', handleLocationChange);
      safeParentRemoveEventListener('pushstate', handleLocationChange);
      safeParentRemoveEventListener('replacestate', handleLocationChange);
    };
  }, [calls, resetParentAppState, getParentAppStateByPlugin]);
};
const disabledPathsRegex = [new RegExp('/breeze-studio/\\d+/agent-builder/chat-agents')];
const getIsDisabledPath = pathname => {
  return disabledPathsRegex.some(regex => regex.test(pathname));
};
export const useIsDisabledPath = () => {
  const [isPathDisabled, setIsPathDisabled] = useState(getIsDisabledPath(getParentPathname()));
  const handlePathnameChange = useCallback(p => setIsPathDisabled(getIsDisabledPath(p)), []);
  useOnParentPathnameChange(handlePathnameChange);
  return isPathDisabled;
};